import { render, staticRenderFns } from "./HistoricoPesagem.vue?vue&type=template&id=59298053&scoped=true"
import script from "./HistoricoPesagem.vue?vue&type=script&lang=js"
export * from "./HistoricoPesagem.vue?vue&type=script&lang=js"
import style0 from "./HistoricoPesagem.vue?vue&type=style&index=0&id=59298053&prod&lang=css"
import style1 from "./HistoricoPesagem.vue?vue&type=style&index=1&id=59298053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59298053",
  null
  
)

export default component.exports